import { render, staticRenderFns } from "./NarrowTitleUnderline.vue?vue&type=template&id=bde299e4&scoped=true"
import script from "./NarrowTitleUnderline.vue?vue&type=script&lang=js"
export * from "./NarrowTitleUnderline.vue?vue&type=script&lang=js"
import style0 from "./NarrowTitleUnderline.vue?vue&type=style&index=0&id=bde299e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde299e4",
  null
  
)

export default component.exports